export var FILE_STATUS_VALUES = {
  DRAFT: 'draft',
  INVALID: 'invalid',
  PROCESSING: 'processing',
  READY: 'ready'
};